import React from 'react';
import { TFunction } from 'i18next';
import { SelectProps } from '@lib/components/Select/Select';
import { SelectOption } from '@lib/components/Select/types';
import ButtonControl from '@lib/components/Select/components/ButtonControl';
import FormTemplateVersionSelect from 'components/FormTemplateVersionSelect/FormTemplateVersionSelect';
import ButtonValueContainer from '@lib/components/Select/components/ButtonValueContainer';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import { materialSymbolsOutlined } from '@lib/enums/common';

type ActionsForSelectedArgs = {
  formTemplateId: string;
  loadingState: boolean;
  onVersionChange: SelectProps['onChange'];
  openScheduleModal: () => void;
  selectedVersionOption?: SelectOption;
  t: TFunction<'translation', undefined>;
  selectedItemsCount: number;
};

export default function getFormTemplateTasksTableActionsForSelected(
  args: ActionsForSelectedArgs,
) {
  const {
    formTemplateId,
    loadingState,
    onVersionChange,
    selectedVersionOption,
    selectedItemsCount,
    t,
    openScheduleModal,
  } = args;
  return [
    <Button
      key="change-schedule"
      buttonText={`${t('reschedule')} (${selectedItemsCount})`}
      buttonType={ButtonTypes.primaryOutlined}
      disabled={loadingState || !selectedItemsCount}
      leftIcon="schedule"
      leftIconClassName={materialSymbolsOutlined}
      onClick={openScheduleModal}
    />,
    <div key="version-select">
      <FormTemplateVersionSelect
        disabled={loadingState}
        hideArchived
        formTemplateId={formTemplateId}
        onChange={onVersionChange}
        value={selectedVersionOption}
        components={{
          Control: ButtonControl,
          ValueContainer: ButtonValueContainer,
        }}
        valueContainerLabel={`${t('apply-version')} (${selectedItemsCount})`}
      />
    </div>,
  ];
}
